import http from '@/utils/http'
import convert from '@/utils/model-convert'
import { SearchArgument } from '@/models/client/channel-credit'

const URL = '/rest/customer/shop/customer-score-log'
const SOURCES_LIST_URL = '/rest/customer/shop/customer-score-log/sourcesList'

export default {
  list ({search}, cb) {
    http.get(URL, {
      params: convert.toJson(search, SearchArgument)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  sourcesList (cb) {
    http.get(SOURCES_LIST_URL).then(response => cb(response)).catch(trace => cb(trace.response))
  }

}



// WEBPACK FOOTER //
// ./src/api/client/channel-credit.js